import axios from '@/request';
import qs from 'qs';

export default {
  async getStadiums(params: any) {
    return axios.get('api/getstadiums', { params });
  },
  async getAdBanners(params: any) {
    return axios.get('api/get-ad-banner', { params })
  },
  async getUsers(params: any) {
    return axios.get('api/getusers', { params });
  },
  async getArea(params: any) {
    return axios.get('api/getarea', { params });
  },
  async getOpenArea(params: any) {
    return axios.get('api/getopenarea', { params });
  },
  async addOpenArea(params: any) {
    return axios.post('api/addopenarea', qs.stringify(params));
  },
  async uploadApk(params: any) {
    return axios.post('cos/uploadapk', params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  async changeFieldValue(params: any) {
    return axios.post('api/change-field', qs.stringify(params));
  },
  async getAreaTree(params: any) {
    return axios.get('api/getareatree', { params });
  },
  async getApplist(params: any) {
    return axios.get('api/applist', { params });
  },
  async sendReleaseSms(params: any) {
    return axios.post('api/send-release-sms', qs.stringify(params))
  },
  async areastr(params: any) {
    return axios.get('api/areastr', { params })
  },
  async authusergroups(params: any) {
    return axios.get('api/auth-user-groups', { params })
  }
};
